import { defineStore } from "pinia";
import Cookies from "js-cookie";

interface UserPreferences {
  local: string;
  selectedFont: { name: string; url: string; variant: string } | null;
}

export const useUserPreference = defineStore("userPreferences", {
  state: (): UserPreferences => ({
    local: Cookies.get("local") || "en",
    selectedFont: Cookies.get("selectedFont")
      ? JSON.parse(Cookies.get("selectedFont")!)
      : null,
  }),

  actions: {
    setLocal(local: string): void {
      this.local = local;
      if (Cookies.get("permittedCookies") === "true") {
        const oneYearFromNow = new Date();
        oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);
        Cookies.set("local", local, {
          expires: oneYearFromNow,
        });
      }
    },

    setFontPreference(font: {
      name: string;
      url: string;
      variant: string;
    }): void {
      this.selectedFont = font;
      if (Cookies.get("permittedCookies") === "true") {
        const oneYearFromNow = new Date();
        oneYearFromNow.setFullYear(oneYearFromNow.getFullYear() + 1);
        Cookies.set("selectedFont", JSON.stringify(font), {
          expires: oneYearFromNow,
        });
      }
    },

    loadPreferences(): void {
      const savedFont = Cookies.get("selectedFont");
      if (savedFont) {
        this.selectedFont = JSON.parse(savedFont);
      }
    },
  },
});
